import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAppDispatch } from "../../../../redux/hooks/redux";
import { updateActiveCompany } from "../../../../redux/features/userStateSlice";

import { updateCompanyAction, UpdateCompanyPayload } from "../actions/UpdateCompanyPayload";

export const useUpdateCompanyInfo = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateCompanyPayload) => updateCompanyAction(data),

    onSuccess: async (updatedCompany) => {
      console.log("=================================");
      console.log("COMPANY UPDATED");
      console.log("=================================");
      console.log("UPDATED COMPANY:", updatedCompany);

      if (!updatedCompany) {
        console.warn("No updated company returned from backend");
        return;
      }

      /*
       * =====================================================
       * 1. ACTUALIZAR REDUX
       * =====================================================
       *
       * updateActiveCompany busca la empresa usando
       * activeCompanyId y actualiza:
       *
       * state.companies[].company
       * state.company
       *
       * Por lo tanto currentCompany se actualizará
       * automáticamente.
       */
      dispatch(updateActiveCompany(updatedCompany));

      /*
       * =====================================================
       * 2. ACTUALIZAR CACHE DE COMPANY INFO
       * =====================================================
       */
      if (updatedCompany?.id !== undefined && updatedCompany?.id !== null) {
        queryClient.setQueryData(["company-info", updatedCompany.id], (current: any) => ({
          ...(current ?? {}),
          ...updatedCompany,
        }));

        await queryClient.invalidateQueries({
          queryKey: ["company-info", updatedCompany.id],
        });
      }

      /*
       * =====================================================
       * 3. INVALIDAR COMPANIES SELF
       * =====================================================
       *
       * No hacemos un fetch manual aquí.
       *
       * Redux ya tiene la información actualizada que acaba
       * de regresar del backend.
       */
      await queryClient.invalidateQueries({
        queryKey: ["companies-self"],
      });

      console.log("REDUX COMPANY UPDATED SUCCESSFULLY");
    },
  });
};
